import { formatPrice } from "@jti/format-price";
import type { MagentoShippingMethod } from "@jti/magento-types";
import { useTranslations } from "@jti/ui";

export const useShippingOptionLabels = () => {
  const { __ } = useTranslations();

  return ({ amount, estimatedDeliveryTime, description, methodTitle }: MagentoShippingMethod) => {
    const priceElementTestId = amount?.value ? "formattedPriceElement" : "freeItemElement";
    const priceElementLabel = `${estimatedDeliveryTime ? `${estimatedDeliveryTime} - ` : ""}${
      amount?.value ? formatPrice(amount) : __("cart.shipping_options.free")
    }`;

    const priceElement = <span data-testid={priceElementTestId}>{priceElementLabel}</span>;

    return {
      title: methodTitle,
      subtitle: description ? (
        <>
          {description} - {priceElement}
        </>
      ) : (
        priceElement
      ),
    };
  };
};
